import React from 'react';
import { t } from '../../utils/i18n';
import { baseXUnit, spacing } from '../../styles/theme';
import FlexDiv from '../common/FlexDiv';
import RouteLink from '../navigation/RouteLink';
import ButtonText from '../elements/ButtonText';
import HyperLink from '../elements/HyperLink';
import Icon, { IconName } from './Icon';

export interface FooterNavLinkProps {
  path: string;
  icon: IconName;
  label: string;
}

const FooterNavLink: React.FunctionComponent<FooterNavLinkProps> = ({
  path,
  icon,
  label
}) => {
  return (
    <div className="footer-nav-link">
      <RouteLink path={path}>
        <HyperLink className="content-row">
          <FlexDiv>
            <div className="icon">
              <Icon name={icon} size={4} color="purple-light" />
            </div>
            <div className="text">
              <ButtonText variant={'primary'}>{t(label)}</ButtonText>
            </div>
          </FlexDiv>
        </HyperLink>
      </RouteLink>
      {/*language=CSS*/}
      <style jsx>{`
        .text {
          padding-top: ${baseXUnit(0.5)};
        }
        .icon {
          flex: 0 0 auto;
          margin-right: ${spacing.one};
        }
      `}</style>
    </div>
  );
};

export default FooterNavLink;
